import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 3l3 5.063","key":"svg-0"}],["path",{"d":"M5 12l6 6","key":"svg-1"}],["path",{"d":"M5 18l6 -6","key":"svg-2"}],["path",{"d":"M21 3l-4.8 9","key":"svg-3"}]]

const IconXPowerY = createReactComponent('outline', 'x-power-y', 'XPowerY', __iconNode);

export default IconXPowerY;